import React from 'react';
import { HashRouter ,  Route, Routes } from "react-router-dom";
// import { HelmetProvider } from 'react-helmet-async'; 
import Admin from './Admin/Admin';
import Sidebar from './Admin/Sidebar';
import Dashboard from './Admin/Dashboard';
import ChangePassword from './Admin/Changepassword';
import Profile from './Admin/Profile';
import Complaintregister from './Admin/Complaintregister';
import Payment from './Admin/Payment';
import Header from './Admin/Header';
import ForgotPassword from './Admin/Forgotpassword';
import Commonloader from './Admin/components/Commonloader';



function App() {
  return (
    <HashRouter >  
      <Routes>
        <Route path="/" element={<Admin/>} />
        <Route path='/admin' element={<Admin/>} />
        <Route path="sidebar" element={<Sidebar/>} />
        <Route path="dashboard" element={<Dashboard/>} />
        <Route path="header" element={<Header/>} />
        <Route path="changepassword" element={<ChangePassword/>} />
        <Route path="profile" element={<Profile/>} />
        <Route path="complaintregister" element={<Complaintregister/>} />
        <Route path="payment" element={<Payment/>} />
        <Route path="forgotpassword" element={<ForgotPassword/>} />
        <Route path="Commonloader" element={<Commonloader/>} />
        
      </Routes>
      </HashRouter >
   
  );
}

export default App;
